// Rich messages contain text and numbered slots, never arbitrary HTML. Tags and
// attributes belong to the original template and cannot be supplied by a translation.
export function richTokens(message){
 const root=[],stack=[{children:root}];let at=0;
 for(const match of message.matchAll(/<\/?\d+\s*\/?>/g)){
  const text=message.slice(at,match.index);if(text)stack.at(-1).children.push(text);
  const token=match[0],id=token.match(/\d+/)[0];
  if(token.startsWith('</')){if(stack.length===1||stack.at(-1).id!==id)throw Error('Unbalanced rich translation');stack.pop();}
  else{const item={id,children:[]};stack.at(-1).children.push(item);if(!token.endsWith('/>'))stack.push(item);}
  at=match.index+token.length;
 }
 if(at<message.length)stack.at(-1).children.push(message.slice(at));
 if(stack.length!==1)throw Error('Unbalanced rich translation');
 return root;
}
export function mapRich(tokens,slots,text){
 return tokens.map(token=>typeof token==='string'?text(token):slots[token.id](mapRich(token.children,slots,text)));
}
